import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import { experimentalStyled as styled } from "@mui/material/styles";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import {
  Badge,
  Button,
  Divider,
  IconButton,
  MenuItem,
  Modal,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import Logo from "../assets/Logo.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ViewCompactIcon from "@mui/icons-material/ViewCompact";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";

import "./header.scss";
import { updateUser } from "../actions/user";
import { Link as link } from "../host/host";
import toast from "react-hot-toast";
import { setColorMode } from "../actions/colorChange";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};
export default function Header() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);

  const [anchorElUser1, setAnchorElUser1] = React.useState(null);
  const [ModalOpen, setModalOpen] = React.useState(false);
  const unApprovedAssets = useSelector((state) => state.newAsset);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const handleOpenUserMenu1 = (event) => {
    setAnchorElUser1(event.currentTarget);
  };
  const handleCloseUserMenu1 = () => {
    setAnchorElUser1(null);
  };
  const handleOpen = () => {
    setModalOpen(true);
  };
  const handleClose = () => {
    setModalOpen(false);
  };

  const [anchorElUser2, setAnchorElUser2] = React.useState(null);
  const handleOpenUserMenu2 = (event) => {
    setAnchorElUser2(event.currentTarget);
  };
  const handleCloseUserMenu2 = () => {
    setAnchorElUser2(null);
  };
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    textAlign: "center",
  }));

  const dispatch = useDispatch();
  const logout = () => {
    let loggingOutId;

    loggingOutId = toast.loading("Please wait we are logging you out...");
    dispatch(updateUser(user?.results._id, { login: "no", system: "none" }));
    setTimeout(() => {
      dispatch({ type: "LOGOUT" });
      navigate("/assets-register/login");
      toast.remove(loggingOutId);
    }, 2000);
  };
  const handleToggle = () => {
    if (mode === "light") {
      dispatch(setColorMode("dark"));
    } else {
      dispatch(setColorMode("light"));
    }
  };
  const navigate = useNavigate();
  let blinkingMessage = false;

  if (
    (user?.results.assets === "Approver" ||
      user?.results.assets === "Administrator") &&
    unApprovedAssets.length >= 1
  ) {
    blinkingMessage = true;
  } else {
    blinkingMessage = false;
  }
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        elevation={0}
        position="fixed"
        // sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}
        style={{
          backgroundColor: `${mode === "dark" ? "#101418" : "#3D4F58"}`,
          // height: "50px",
        }}
      >
        <Box
          style={{
            marginTop: "7px",
            marginLeft: 100,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginTop: "-15px",
            }}
          >
            <img
              style={{ marginLeft: "170px" }}
              width={50}
              height={"auto"}
              src={Logo}
              alt="src logo"
            />
            <Typography
              variant="h5"
              style={{
                color: `${mode === "dark" ? "#0883FF" : "#17b859"}`,
                fontWeight: "bold",
                marginLeft: "5px",
                fontSize: "20px",
              }}
            >
              <Link
                style={{
                  color: `${mode === "dark" ? "#0883FF" : "#17b859"}`,
                  fontWeight: "bold",
                  marginLeft: "5px",
                  fontSize: "20px",
                  textTransform: "none",
                  textDecoration: "none",
                }}
                to={"/assets-register/"}
              >
                Rosoftsavvy
              </Link>
            </Typography>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <Tooltip title="click to logout">
              <IconButton
                style={{
                  backgroundColor: `${mode === "dark" ? "#0883FF" : "#17b859"}`,
                }}
                onClick={handleOpen}
              >
                <LogoutIcon style={{ color: "#fff" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="sFass Apps">
              <IconButton onClick={handleOpenUserMenu2}>
                <ViewCompactIcon style={{ fontSize: "30px", color: "#fff" }} />
              </IconButton>
            </Tooltip>

            <Badge
              color="secondary"
              badgeContent={unApprovedAssets.length}
              max={100}
            >
              <Tooltip title="Toggle notifications panel">
                <IconButton onClick={handleOpenUserMenu1}>
                  <NotificationsIcon style={{ color: "#fff" }} />
                </IconButton>
              </Tooltip>
            </Badge>
            <Tooltip title="mode">
              <IconButton onClick={handleToggle}>
                {mode === "light" ? (
                  <LightModeIcon
                    style={{
                      color: "#ffffff",
                    }}
                  />
                ) : (
                  <DarkModeIcon
                    style={{
                      color: "#ffffff",
                    }}
                  />
                )}
              </IconButton>
            </Tooltip>
            <Typography>
              <strong
                style={{
                  color: `${mode === "dark" ? "#0883FF" : "#17b859"}`,
                  fontSize: "16px",
                }}
              >
                RSS.
              </strong>
              <em style={{ color: "#FFFFFF" }}>Assets</em>
            </Typography>
          </div>
        </Box>
        <Menu
          sx={{ mt: "45px" }}
          id="menu-appbar"
          anchorEl={anchorElUser1}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser1)}
          onClose={handleCloseUserMenu1}
        >
          <MenuItem style={{ display: "flex", flexDirection: "column" }}>
            <Typography>Notifications</Typography>
          </MenuItem>
          <Divider />
          <MenuItem style={{ display: "flex", flexDirection: "column" }}>
            {!blinkingMessage && <Typography>No messages available</Typography>}
            {blinkingMessage && (
              <Typography
                onClick={() => navigate("/assets-register/approvals")}
              >
                Some Assets needs your approval{" "}
              </Typography>
            )}
          </MenuItem>
        </Menu>
        <Menu
          sx={{ mt: "45px" }}
          id="menu-appbar"
          anchorEl={anchorElUser2}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser2)}
          onClose={handleCloseUserMenu2}
        >
          <Paper
            elevation={0}
            style={{
              width: "240px",
              padding: "10px",
              overflow: "hidden",
              height: "400px",
            }}
          >
            <Typography variant="h5">Apps</Typography>
            <Divider style={{ marginBottom: "40px" }} />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3,1fr)",
                gap: "15px",
              }}
            >
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <Typography>sFasss</Typography>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${link}/assets-register`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Assets Register
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${link}/reconciliation`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Reconciliation
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${link}/stock`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Stock manager
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${link}/investment`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Portfolio Manager
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>

                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${link}/advice`}
                  target="_blank"
                  rel="noreferrer"
                >
                  eAdvice
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>

                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${link}/claim`}
                  target="_blank"
                  rel="noreferrer"
                >
                  eClaim
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${link}/insurance`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Risk Manager
                </a>
              </Item>
            </div>
          </Paper>
        </Menu>
      </AppBar>

      <Modal
        open={ModalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={style}
          style={{ backgroundColor: "#dfdfdf" }}
          className="animate__animated animate__pulse"
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Logout Confirmation
          </Typography>
          <Typography style={{ marginTop: "10px", fontWeight: "bold" }}>
            {user?.results.firstName + " " + user?.results.lastName}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, marginBottom: "20px" }}
          >
            Are You Sure You Want To Exit?
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Button
              style={{ backgroundColor: "#116149" }}
              onClick={logout}
              size="small"
              variant="contained"
            >
              Yes <CheckIcon />
            </Button>
            <Button
              color="error"
              className="btn-danger"
              size="small"
              onClick={handleClose}
              variant="contained"
            >
              CANCEL <CancelIcon />
            </Button>
          </div>
        </Box>
      </Modal>
    </Box>
  );
}
